

export  async function fetchStaffs(data) {
    const params = new URLSearchParams(data).toString();
    let types =[];
    try {
        const response = await fetch(`https://api.shop.actualoptic.kz/api/staffs?${params}`,data);
        if (!response.ok) {
            throw new Error(`Ошибка загрузки: ${response.statusText}`);
        }
        types = await response.json();
    } catch (error) {
        console.error("Ошибка при загрузке сотрудников:", error);
        types = [];
    }
    return types;
}
